<button
        class="button"
        [disabled]="disabled"
        [type]="type"
        [ngClass]="[
        'button--'+appearance,
        'button--'+expand,
        'button--'+size,
        'button--'+color,
        ]"
        (click)="onClick.emit()"
>
    <div class="button__content">
        <ng-content></ng-content>
    </div>
</button>
